import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import {L_SHOW_KEYS} from "@COMPONENTS/product/common/popup/common/constant";
import * as style from "@COMPONENTS/style/productlist/productlist";
import {Checkbox} from "@FRAMEWORK/ui/desktop/input";
import {GoodsFilter} from "@QUERIES/prdt/goods/useGoodsFilter";
import React, {useCallback, useMemo, useRef, useState} from "react";
import useFilterStore from "../../common/filterHook";

const LocalLvl4ListComponent = (prop: GoodsFilter) => {
	const lvl4ListData = prop.lvl4List.replaceAll("|", "").split("^");
	const lvl4List = [];
	for (let i = 0; i < lvl4ListData.length; i += 2) {
		const code = lvl4ListData[i];
		const name = lvl4ListData[i + 1];
		lvl4List.push({code, name});
	}

	const {getFilter, addFilter, removeFilter} = useFilterStore();
	const handleClick = (e: React.ChangeEvent<HTMLInputElement>) => {
		const {value, checked} = e.target;
		const text = e.target.parentNode.textContent;
		checked && addFilter("dspSid", value, text);
		!checked && removeFilter("dspSid", value);
	};

	return (
		<style.AreaGridList>
			{lvl4List &&
				lvl4List.map((item, index) => (
					<li key={index}>
						<Checkbox
							type="checkbox"
							id={`dspSid${item.code}`}
							value={item.code}
							onChange={handleClick}
							checked={getFilter()?.some(v => v.value === item.code) || false}
						/>
						<label htmlFor={`dspSid${item.code}`}>{item.name}</label>
					</li>
				))}
		</style.AreaGridList>
	);
};

const LocalLvl4List = (props: GoodsFilter) => (
	<ErrorBoundary logMsg="HeadFilter Lvl4List Error">
		<LocalLvl4ListComponent {...props} />
	</ErrorBoundary>
);

const LocalHeadAreaComponent = () => {
	const {getFilter, removeFilter, setFilter} = useFilterStore();

	/* 선택 옵션리스트 (순서보정) */
	const selectedList = useMemo(() => {
		let arr = [];
		const filters = getFilter();

		if (filters && filters.length > 0) {
			for (const key of L_SHOW_KEYS) {
				if (key === "minPrice") {
					const minPrice = filters.find(v => v.key === "minPrice");
					if (minPrice) arr = [...arr, {key: "price", text: minPrice.text}];
				} else if (key === "maxPrice") {
					const maxPrice = filters.find(v => v.key === "maxPrice");
					const priceObject = arr.find(v => v.key === "price");
					if (priceObject && maxPrice) priceObject.text += ` ~ ${maxPrice.text}`;
				} else {
					arr = [...arr, ...filters.filter(v => v.key === key)];
				}
			}
		}
		return arr;
	}, [getFilter()]);

	const handleSelected = e => {
		/* X버튼 */
		const {id: key, value} = e.target;
		if (key === "price") {
			const setArr = getFilter().filter(item => !["minPrice", "maxPrice"].includes(item.key)) || [];
			setFilter(setArr);
		} else if (key && value) {
			removeFilter(key, value);
		}
	};
	/* 전체삭제 */
	const handleReset = useCallback(() => {
		const setArr = getFilter().filter(item => item.key === "sort");
		setFilter(setArr);
	}, []);

	const scrollRef = useRef(null);
	const [isDragging, setIsDragging] = useState(false);
	const [dragStartX, setDragStartX] = useState(null);
	const [scrollStartX, setScrollStartX] = useState(null);

	// 버튼을 클릭 했을 때
	const handleMouseDown = e => {
		e.preventDefault();
		setIsDragging(true);
		setDragStartX(e.clientX);
		setScrollStartX(scrollRef.current.scrollLeft);
	};

	// 마우스가 움직일 때
	const handleMouseMove = e => {
		if (!isDragging) return;

		const dragDistance = e.clientX - dragStartX;
		scrollRef.current.scrollLeft = scrollStartX - dragDistance;
	};

	// 마우스 버튼을 놨을 때
	const handleMouseUp = () => {
		setIsDragging(false);
	};

	// 마우스가 컨테이너를 벗어났을 때
	const handleMouseLeave = () => {
		if (isDragging) {
			setIsDragging(false);
		}
	};

	return (
		<>
			<style.FilterTagContainer>
				<style.FilterTitle>필터</style.FilterTitle>
				{/* 필터 선택 데이터 */}
				<style.FilterTagBox
					ref={scrollRef}
					onMouseDown={handleMouseDown}
					onMouseMove={handleMouseMove}
					onMouseUp={handleMouseUp}
					onMouseLeave={handleMouseLeave}
				>
					{selectedList.length > 0 &&
						selectedList.map((item, index) => (
							<li key={index}>
								{item.text}
								<style.FilterTagDeleteButton value={item.value} id={item.key} onClick={handleSelected}>
									닫기
								</style.FilterTagDeleteButton>
							</li>
						))}
				</style.FilterTagBox>
			</style.FilterTagContainer>
			{/* 필터초기화 */}
			<style.ResetButton type="button" onClick={handleReset}>
				전체 삭제
			</style.ResetButton>
		</>
	);
};

const LocalHeadArea = () => (
	<ErrorBoundary logMsg="HeadFilter HeadArea Error">
		<LocalHeadAreaComponent />
	</ErrorBoundary>
);

export {LocalHeadArea, LocalLvl4List};
